interface IProps {
    size?: number
    className?: string
}

/**
 * The Tap to Pay on iPhone glyph — an SVG equivalent of Apple's
 * `wave.3.right.circle` SF Symbol, required by the Human Interface Guidelines
 * for the checkout button. Drawn with currentColor so it inherits the button's
 * text colour (SF Symbols aren't available inside the web view).
 */
export default function TapToPayIcon({ size = 20, className }: IProps) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.6}
            strokeLinecap="round"
            aria-hidden="true"
            focusable="false"
        >
            <circle cx="12" cy="12" r="10.2" />
            <path d="M8.5 10a2.6 2.6 0 0 1 0 4" />
            <path d="M11 8.4a4.7 4.7 0 0 1 0 7.2" />
            <path d="M13.5 6.8a6.8 6.8 0 0 1 0 10.4" />
        </svg>
    )
}
